module.exports = __webpack_public_path__ + "img/green-rectangle-table-6.d50d9346.png";